<template>
    <div class="py-2 md:py-4 relative">
        <div class="flex flex-col md:flex-row md:justify-between items-start md:items-center mb-5">
            <div>
                <h2 class="text-2xl font-semibold text-slate-800">
                    10x Travel Plus
                </h2>
                <p class="text-slate-500 text-sm">
                    Access your exclusive travel benefits and features
                </p>
            </div>
        </div>
        
        <router-view></router-view>
    </div>
</template>

<script setup>
</script>
